import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { BasicService } from '../../providers/basic';
import { environment as config } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { AuthHttp } from 'angular2-jwt';
import { AuthService } from '../auth/auth.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import { ISession } from '../../models/session';

@Injectable()
export class ParticipantsService extends BasicService {
  private API = config.certificates.url;

  constructor(
    protected authService: AuthService,
    protected translate: TranslateService,
    private http: AuthHttp
  ) {
    super(authService, translate);
  }

  public getParticipants(session: ISession, notify: boolean = false): Observable<any> {
    return this.http
      .get(`${this.API}/users?sessionId=${session.id}&lang=${session.language}`)
      .map(res => this.extractData(res, notify))
      .catch(err => {
        // Ignore 404 not found errors and return empty array
        if (err.status === 404) {
          return Observable.of([]);
        }
        return this.handleError(err);
      });
  }

  public updateParticipant(userId: number, session: ISession, data: any, notify: boolean = true): Observable<any> {
    return this.http
      .patch(`${this.API}/users/${userId}`, data, {
        params: { sessionId: session.id }
      })
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public getPDF(session: ISession, userId: number): Observable<Blob> {
    return this.http
      .get(`${this.API}/export/toPDF?sessionId=${session.id}&userId=${userId}&lang=${session.language}`, {
        responseType: 3 // ResponseContentType.Blob
      })
      .map(res => {
        return new Blob([res.blob()], { type: 'application/pdf' });
      })
      .catch(err => this.handleError(err));
  }

  public getEmailStats(session: ISession): Observable<{ unique_certificates_sent: number; total_certificates_sent: number }> {
    return this.http
      .get(`${this.API}/participants/email/stats?sessionId=${session.id}`)
      .map(res => this.extractData(res, false))
      .catch(err => this.handleError(err));
  }

  public exportReportedMinutes(session: ISession): Observable<any> {
    return this.http
      .post(`${this.API}/users/export-aggregated-connection-time?sessionId=${session.id}&lang=${session.language}`, {})
      .catch(err => this.handleError(err));
  }

  public resetManualUpdateMode(userId: number, session: ISession): Observable<any> {
    return this.http
      .post(`${this.API}/users/${userId}/reset-manual-update-mode?sessionId=${session.id}`, {})
      .map(res => this.extractData(res, false))
      .catch(err => this.handleError(err));
  }

  public getParticipantsStats(session: ISession): Observable<Blob> {
    return this.http
      .get(`${this.API}/stats/participants-stats?sessionId=${session.id}&lang=${session.language}`, {
        responseType: 3 // ResponseContentType.Blob
      })
      .map(res => {
        return new Blob([res.blob()], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      })
      .catch(err => this.handleError(err));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/participants.service.ts